import useTracksStore, {
  MEDIA_FILES_TRACK_ID,
  TrackType,
} from '@/shared/store/tracks.store.tsx'
import useMediaStore from '@/shared/store/media.store.tsx'
import { getAudioBufferFromAudioUrl } from '@/utils/get-audio-buffer-from-audio-url.ts'
import type {
  AudioFormClip,
  MediaFileAsset,
} from '../../../../audio-form/data/dto/audio-form-input.ts'
import { mapAudioFormClipToClipPositions } from './map-audio-form-clip-to-clip-positions.ts'

export const mapMediaFileLayerToClips = async (
  asset: MediaFileAsset,
  clip: AudioFormClip,
  track?: string
): Promise<void> => {
  // Load asset into media store
  const { addMedia } = useMediaStore.getState()
  if (!asset.uri) return

  // Load clip into tracks store
  const { addClip } = useTracksStore.getState()
  const trackId = track ?? MEDIA_FILES_TRACK_ID

  // todo: store file name and use it as id
  addClip(trackId, {
    id: crypto.randomUUID(),
    type: TrackType.MediaFiles,
    trackId,
    name: '',
    mediaId: asset.fileId,
    src: asset.uri,
    ...mapAudioFormClipToClipPositions(clip, asset.duration ?? 0), // todo: fix this
  })

  const audioBuffer = await getAudioBufferFromAudioUrl(asset.uri)
  addMedia(asset.fileId, audioBuffer)
}
